<template>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50" v-if="count > 0">
            <tr>
              <th
                v-for="(col, index) in columns"
                :key="col + index"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap text-uppercase"
              >
                {{ col }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="count == 0">
              <td
                :colspan="columns.length"
                class="bg-white px-6 py-4 whitespace-nowrap text-sm text-center font-medium text-gray-500"
              >
                <i class="fas fa-folder-open mr-1"></i>
                Aucun produit trouver
              </td>
            </tr>
            <tr
              v-for="(item, index) in items"
              :key="`${item.id}-${index}`"
              class="bg-white"
              :class="{ 'bg-gray-50': index % 2 }"
            >
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ item.code }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                &euro; {{ item.price }}
                <span v-if="item.price_type && item.price_type !== 'FIXED'">
                  / {{ priceLabels[item.price_type] }}
                </span>
                <span v-else>(Prix fixe)</span>
              </td>
              <td class="px-6 py-4 text-sm text-gray-500" style="min-width: 320px">
                <p class="inline-block mb-0">
                  {{ item.description }}
                </p>
                <a
                  v-if="item.link"
                  :href="item.link"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  class="mt-1 whitespace-nowrap text-indigo-600 hover:text-indigo-900 w-12 block"
                >
                  Lien fournisseur
                </a>
              </td>
              <td class="px-6 py-4 gap-2 grid whitespace-nowrap text-left text-sm font-medium">
                <router-link
                  v-if="item?.id"
                  :to="`/products/${item.id}`"
                  class="text-indigo-600 hover:text-indigo-900 w-12 block"
                  :class="{ '-mt-1': item.link }"
                >
                  Voir
                </router-link>
                <router-link
                  v-if="item?.id"
                  :to="`/products/${item.id}/edit`"
                  class="text-indigo-600 hover:text-indigo-900 w-12 block"
                >
                  Modifier
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="px-4 sm:px-6 md:px-8 -mt-1">
      <UIAtomPagination v-model="page" :offset="offset" :limit="limit" :count="count" />
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import useApi from '@/hooks/useApi'
import UIAtomPagination from '@/components/UI/Atom/Pagination'
import { useRoute } from 'vue-router'

const priceLabels = {
  FIXED: '',
  PER_METER: 'M',
  PER_SQUARE_METER: 'M²',
}

export default {
  components: {
    UIAtomPagination,
  },
  setup() {
    const api = useApi()
    const route = useRoute()

    const page = ref(route.query.page > 0 ? Number(route.query.page) : 1)
    const count = ref(-1)
    const limit = ref(10)
    const items = ref([])
    const offset = computed(() => limit.value * (page.value - 1))

    const refresh = () => {
      api.products.list({ limit: limit.value, offset: offset.value }).then(({ data }) => {
        if (data.count || count.value === -1) count.value = data.count
        if (data.list && data.list.length) items.value = data.list
      })
    }
    refresh()
    watch(() => page.value, refresh)

    const columns = ['Code', 'Prix', 'Description', '']
    return { columns, page, limit, offset, count, items, priceLabels }
  },
}
</script>

<style></style>
